/**
 * Auto-Carousel Controller for Category & Product Sliders
 * Smoothly advances carousel 1 card at a time with seamless looping and pause on hover.
 */
(function () {
  function initAutoCarousels() {
    const containers = document.querySelectorAll(
      'slideshow-component[autoplay], .resource-list__carousel, [data-auto-carousel]'
    );

    containers.forEach((container) => {
      // Find the scrollable track
      const scroller =
        container.querySelector('slideshow-slides') ||
        container.querySelector('[ref="scroller"]') ||
        (container.classList.contains('resource-list__carousel') ? container : null) ||
        container.querySelector('.resource-list__carousel');

      if (!scroller) return;
      if (scroller._autoCarouselInitialized) return;
      scroller._autoCarouselInitialized = true;

      // Determine autoplay speed (seconds)
      const attrSpeed =
        container.getAttribute('autoplay') ||
        container.closest('[autoplay]')?.getAttribute('autoplay') ||
        scroller.getAttribute('data-autoplay-speed') ||
        '3';

      const intervalSec = parseFloat(attrSpeed) || 3;
      const intervalMs = Math.max(1500, intervalSec * 1000);

      let timer = null;
      let isPaused = false;

      function getStepDistance() {
        const firstCard = scroller.querySelector('slideshow-slide, .resource-list__slide, .resource-list__item, .collection-card');
        if (!firstCard) return 320;

        const cardWidth = firstCard.getBoundingClientRect().width || firstCard.offsetWidth;
        const style = window.getComputedStyle(scroller);
        const gap =
          parseFloat(style.columnGap || style.gap) ||
          parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--resource-list-column-gap')) ||
          16;

        return cardWidth + gap;
      }

      function advance() {
        if (isPaused || document.hidden) return;

        const step = getStepDistance();
        const currentScroll = scroller.scrollLeft;
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;

        // If at or near the end (within half a step or 20px), loop back to the start
        if (currentScroll >= maxScroll - Math.min(25, step / 2)) {
          scroller.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          const nextTarget = Math.min(maxScroll, currentScroll + step);
          scroller.scrollTo({ left: nextTarget, behavior: 'smooth' });
        }
      }

      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(advance, intervalMs);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Pause on mouse hover so shoppers can click comfortably
      container.addEventListener('mouseenter', () => {
        isPaused = true;
        stop();
      });

      container.addEventListener('mouseleave', () => {
        isPaused = false;
        start();
      });

      // Pause during touch interactions
      container.addEventListener(
        'touchstart',
        () => {
          isPaused = true;
          stop();
        },
        { passive: true }
      );

      container.addEventListener(
        'touchend',
        () => {
          isPaused = false;
          start();
        },
        { passive: true }
      );

      // Start automatic movement
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoCarousels);
  } else {
    initAutoCarousels();
  }

  window.addEventListener('load', initAutoCarousels);
  document.addEventListener('shopify:section:load', initAutoCarousels);
})();
